<template>
  <div class='EnbMp'>
    <div class="card-mp">
      <div class="top-check">
        <input :disabled="Empresa.mp" @change="toggle" :checked="Empresa.mp" type="checkbox"/>
        <label>Mercado Pago</label>
      </div>
      <div class="cont-input">
        <input-reg
        text="Public Key"
        placeholder="Os dados enviados estão ocultos por segurança"
        @update:modelValue="newValue => publickey = newValue"
        :cont="{ textAlign: 'left' }"
        :label="{ marginLeft: '3px' }"
        :input="{ fontSize: '16px', padding: '2%', width: '96%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
        placered
        />
        <input-reg
        text="Access Token"
        placeholder="Os dados enviados estão ocultos por segurança"
        @update:modelValue="newValue => accesstoken = newValue"
        :cont="{ textAlign: 'left' }"
        :label="{ marginLeft: '3px', marginTop: '8px' }"
        :input="{ fontSize: '16px', padding: '2%', width: '96%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
        placered
        />
      </div>
      <div class="cont-button">
        <button @click="push">Salvar</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import InputReg from '@/components/EnbPainel/Produtos/Register/InputReg'
export default {
  name: 'EnbMp',
  components: { InputReg },
  data () {
    return {
      publickey: '',
      accesstoken: ''
    }
  },
  computed: {
    ...mapGetters(['Empresa'])
  },
  methods: {
    ...mapActions(['_UpdateParamMp', '_UpdatePayMode']),
    push () {
      this._UpdateParamMp({ publickey: this.publickey, accesstoken: this.accesstoken })
    },
    toggle () {
      if(this.Empresa.mp) {
        return
      }
      this._UpdatePayMode({ mp: true, wa: false })
    }
  }
}
</script>

<style scoped>
.EnbMp {
  display: flex;
}

.card-mp {
  width: 45%;
  border: thin solid #CCCCCC;
  border-radius: 10px;
}

.top-check {
  height: 35px;
  display: flex;
  align-items: center;
  border-bottom: thin solid #CCCCCC;
  background-color: #EEEEEE;
  color: #648EEA;
}

input {
  margin-left: 2%;
}

.cont-input {
  padding: 2%;
}

.cont-button {
  display: flex;
  padding-left: 2%;
  padding-bottom: 2%;
}

button {
  border: 0;
  background-color: #000000;
  color: #FFFFFF;
  padding: 1.5%;
  border-radius: 5px;
  cursor: pointer;
}

@media (max-width: 500px) {
  .card-mp {
    width: 100%;
    margin: auto;
  }
}
</style>
